import React from 'react';

import Date from '../../../common/date';
import Percentage from '../../../common/Percentage';
import { formatAmount } from '../../../common/money';


export default [
  {
    Header: 'Date',
    accessor: 'dateTime',
    className: 'u-text-left',
    Cell: ({ value }) => <Date>{value}</Date>,
  },
  {
    Header: 'Product name',
    accessor: 'productName',
  },
  {
    Header: 'SKU',
    accessor: 'productSku',
  },
  {
    Header: 'Brand',
    accessor: 'productBrand',
  },
  {
    Header: 'Category',
    accessor: 'productCategory',
  },
  {
    Header: 'Products expected',
    accessor: 'previousInventory',
  },
  {
    Header: 'Products counted',
    accessor: 'newInventory',
  },
  {
    Header: 'Shrinkage %',
    accessor: 'shrinkagePercentage',
    Cell: ({ value }) => <Percentage>{value}</Percentage>, // eslint-disable-line react/prop-types
  },
  {
    Header: 'Shrinkage Cost',
    accessor: 'totalShrinkageCost',
    Cell: ({ value }) => formatAmount(value),
  },
];
